import { useContext } from 'react';

import { useMutation } from '@tanstack/react-query';

import { ContractEntry } from '@octopus/api';
import { getName } from '@octopus/contract-types';
import {
  ContractProps,
  SimulationInput,
  fetchPostTerminationSimulation,
} from '@octopus/termination-api';

import { useSnackbar } from '../../../modules/hooks/useSnackbar';
import { AppContext } from '../../context';
import {
  ContractSummaryWithFgtsBalance,
  TerminationSimulationInputs,
} from '../types';

export const useGenerateSimulation = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { appContext } = useContext(AppContext);
  const { showSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (simulationInput: SimulationInput) => {
      console.log(simulationInput);
      const name =
        simulationInput.name ||
        getName(simulationInput.contracts?.[0] as ContractEntry);
      return fetchPostTerminationSimulation({
        body: {
          ...simulationInput,
          name,
        },
        pathParams: {
          organizationId: appContext.organization.organizationId,
        },
      });
    },
    onSuccess: () => {
      showSnackbar({
        Message: 'Simulação gerada com sucesso',
        isOpen: true,
      });
      onSuccess();
    },
    onError: () => {
      showSnackbar({
        Message: 'Erro ao gerar simulação',
        isOpen: true,
      });
    },
  });
};

export const toTerminationInput = (
  form: TerminationSimulationInputs,
  contracts: ContractSummaryWithFgtsBalance[],
): SimulationInput => {
  console.log(contracts);
  const name = contracts.length > 1 ? form.identifier : contracts?.[0]?.name;
  return {
    name,
    terminationProps: {
      noticeDate: form.noticeStartDate || form.terminationDate,
      terminationDate: form.terminationDate,
      paymentDate: form.paymentDate,
      br: {
        motivo: form.reason,
      },
    },
    contracts: contracts.map((contract) => toContractProps(form, contract)),
  };
};

const toContractProps = (
  form: TerminationSimulationInputs,
  contract: ContractSummaryWithFgtsBalance,
): ContractProps => {
  const valorBaseFgts = form.fgtsBalance || contract.fgtsBalance;
  return {
    contractId: contract.contractId,
    companyId: contract.companyId,
    br: {
      valorBaseFgts,
    },
  };
};
